import AppPaths from '../AppPaths';

const LANGUAGE_TREE = '(/[a-z]{2}(-[a-z]{2})?)?';

/**
 * Whether the router is on `page` (e.g. `/products`). Main also serves its pages under each
 * language's URL tree (`/de/products`, `/fr-ca/shop`) and renders legacy components there, which
 * see that prefixed path. The language segment is matched by its shape because legacy must not
 * import main's locale list.
 */
export function isPagePath(pathname: string, page: string) {
  return new RegExp(`^${LANGUAGE_TREE}${page}$`).test(pathname);
}

/** Whether the router is on the shop, in any of main's language trees. */
export function isShopPath(pathname: string) {
  return isPagePath(pathname, AppPaths.Shop);
}
